import AbsenteeismResultForm from "./absenteeismResult";
import { Modal } from "../../../components/others/Modal/index";

type TProps = {
  toggleModal: boolean;
  urlTittle?: string;
  patient:any
  onClose: Function
};

const AbsenteeismResult = ({ toggleModal, urlTittle, onClose, patient }: TProps) => {
  const styles = "text-2xl text-red-500 font-bold";
  return (
    <>
      <Modal
        show={toggleModal}
        modalTitle={"Detalle de ausentismo"}
        titleStyle={styles}
        urlTittle={urlTittle}
        onClose={()=> onClose?.()}
      >
        <AbsenteeismResultForm
        patient={patient} />
      </Modal>
    </>
  );
};

export default AbsenteeismResult;
